<app-list-page
  [headline]="
    (lastResult.totalNumberResultsets === 1 ? 'skill.size.singular' : 'skill.size.plural')
      | translate: { skills: lastResult.totalNumberResultsets || 0 }
  "
  (downloadList)="downloadTheList()"
  [detailsLoaded]="skillId && items.size > 0 ? true : false">
  <hoc-filter-block
    data-testid="skill-filter-block"
    filter
    [textSearch]="searchForName"
    [statusFilterVisible]="false"
    (changed)="filterBlockChanged($event)"
    [defaultSorting]="sorting">
    <ng-template #filtering>
      <div class="rounded-full border-2 border-ui-interactive bg-ui-surface-rise px-4 py-2">
        <gx-dropdown
          data-testid="skill-filter-dropdown"
          [switchMode]="true"
          label="filter.searchOptions"
          icon="chevron-down"
          openWith="pill"
          [isRightAligned]="true"
          notificationAt="whenSelected"
          iconAt="right"
          [createCaption]="createCaptionForDropdown"
          [isSelectable]="true"
          [allSelectable]="false"
          [menuItems]="searchForOptions"
          [defaultSelectedItems]="[searchFor]"
          (menuItemSelected)="filterSelected($event)"
          [multiSelect]="false"
          [withSearch]="false" />
      </div>
    </ng-template>
  </hoc-filter-block>
  <hoc-grouped-list
    data-testid="skill-list"
    list
    id="skillList"
    [loading]="loading"
    [groupLetters]="groupLetters"
    [items]="items"
    [loadingBlock]="loadingBlock"
    [footerBlock]="footerBlock"
    [groupBlock]="groupBlock"
    [itemBlock]="itemBlock"
    [emptyItemsBlock]="emptyItemsBlock"
    (scrolledToEnd)="scrolledToEnd()">
  </hoc-grouped-list>
  <app-skill-details details [skill]="selectedSkill" (closeClicked)="closeDrawer()"></app-skill-details>
</app-list-page>

<ng-template #emptyItemsBlock>
  <app-empty-list-page (backButtonClicked)="handleEmptyList()"></app-empty-list-page>
</ng-template>

<ng-template #groupBlock let-letter>
  <h3 class="list-title-text">{{ letter }}</h3>
</ng-template>

<ng-template #loadingBlock>
  <app-list-placeholder [hasTitle]="true" [columnCount]="2" />
</ng-template>

<ng-template #itemBlock let-item>
  <app-list-item [data]="getSkillListItem(item)" (onClicked)="clickedOnSkill(item)"></app-list-item>
</ng-template>

<ng-template #footerBlock>
  <div #footerContainer class="px-3 py-4">
    <!-- TODO: Add a <gx-button>Load more</gx-button> also with infinite scroll. in case something is not working user has control!-->
    @if (loadMode === 'paged' && items.size > 0) {
      <gx-pagination
        data-testid="skill-list-pagination"
        [data]="pagination"
        (newPage)="gotoPage($event)"
        [availablePageSizes]="config.pageSizes"
        [currentPageSize]="filter.pageSize"
        [lengthBeginSegment]="4"
        [lengthEndSegment]="4"
        (newPageSize)="newPageSize($event)" />
    }

    @if (loadMode === 'infinite' && canLoadMore) {
      <app-list-placeholder [columnCount]="2" (click)="scrolledToEnd()" />
    }
  </div>
</ng-template>
